// Тексти, що приходять з бази чи масивів і не мають власних ключів: оригінал (укр) → переклад.
// Якщо фрази тут немає, показується оригінал.
export const PHRASES_EN: Record<string, string> = {
    "Всі": "All",
    "Екіпірування": "Equipment",
    "Транспортні засоби": "Vehicles",
    "Будматеріали": "Building materials",
    "Контейнери": "Containers",
    "Сервер": "Server",
    "Для себе": "For myself",
    "Для друга": "For a friend",
};
